export const COOKIE_NAME_SESSION_ID = "sessionId";

export const fontFamilyUrl =
  "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400;1,600;1,700&family=Source+Sans+Pro:ital,wght@0,300;0,400;1,600&display=swap";

export const ADMIN_DOMAIN_NAME = process.env.RAZZLE_APP_ADMIN_URL
  ? new URL(process.env.RAZZLE_APP_ADMIN_URL || "")?.hostname
  : "";
